import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import VoucherBalanceList from './VoucherBalanceList';

import * as actions from 'actions/index';
import './style.css';

const VoucherBalance = ({ voucherBalance, onFetchingVoucherBalance }) => {
  useEffect(() => {
    onFetchingVoucherBalance();
  }, []);

  return (
    <div className="company-voucher-container">
      {voucherBalance.length > 0 ? (
        <VoucherBalanceList items={voucherBalance} />
      ) : (
        <div>You don't have any voucher yet</div>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  voucherBalance: state.teamVoucherReducer.voucherBalance,
});

const mapDispatchToProps = dispatch => ({
  onFetchingVoucherBalance: () => dispatch(actions.fetchingVoucherBalance()),
});

export default connect(mapStateToProps, mapDispatchToProps)(VoucherBalance);



// WEBPACK FOOTER //
// ./src/containers/TeamVoucher/VoucherBalance/index.js